export type ColorKeys = 'red' | 'white' | 'black' | 'gray' | 'kv'
export const colors: Record<ColorKeys, string> = {
  kv: '#fff',
  red: '#E54802',
  white: '#fff',
  black: '#242424',
  gray: '#CFC5BA',
}

export const colorsMap: Record<ColorKeys, string> = {
  kv: colors.white,
  red: colors.white,
  gray: colors.black,
  black: colors.white,
  white: colors.black,
}

export const colorKeysMap: Record<ColorKeys, ColorKeys> = {
  kv: 'white',
  red: 'white',
  gray: 'black',
  black: 'white',
  white: 'black',
}
